export default __webpack_public_path__ + "static/media/20230505_WellWeb_Home x Dhanar X Komune Last 150-06.6785e0df.png";